import React from 'react';

import { UserLink } from '@/components/entity-links';
import { cn } from '@/lib/utils';
import { CustomUserSchema } from '@/services/api/generated/matterEventsService';

interface UserAvatarProps {
  user?: CustomUserSchema | null;
  size?: 'xs' | 'sm' | 'md';
  className?: string;
}

export const UserAvatar: React.FC<UserAvatarProps> = ({
  user,
  size = 'sm',
  className,
}) => {
  const sizeClasses = {
    xs: 'h-4 w-4 text-[8px]',
    sm: 'h-5 w-5 text-[10px]',
    md: 'h-6 w-6 text-xs',
  };

  const initials = user
    ? `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase()
    : 'S';

  // Fallback to initials with more subtle colors
  const colors = [
    'bg-zinc-100 text-zinc-600',
    'bg-blue-100 text-blue-600',
    'bg-purple-100 text-purple-600',
    'bg-emerald-100 text-emerald-600',
    'bg-amber-100 text-amber-600',
  ];

  // Generate consistent color based on name
  const colorIndex = (user?.first_name?.charCodeAt(0) || 0) % colors.length;

  const AvatarContent = (
    <div
      className={cn(
        'rounded-full flex items-center justify-center font-medium flex-shrink-0',
        sizeClasses[size],
        user?.avatar ? 'bg-gray-50' : colors[colorIndex],
        className,
      )}
    >
      {user?.avatar ? (
        <img
          src={user.avatar}
          alt={`${user.first_name || ''} ${user.last_name || ''}`}
          className="h-full w-full rounded-full object-cover"
        />
      ) : (
        initials
      )}
    </div>
  );

  if (user) {
    return (
      <UserLink
        entityId={user.id}
        className="flex-shrink-0 block border-none"
        disableNavigation
      >
        {AvatarContent}
      </UserLink>
    );
  }

  return AvatarContent;
};
